import { queryOptions } from "@tanstack/react-query";

import {
    type SearchTrendsByCountryParams,
    SEARCH_TRENDS_BY_COUNTRY_ENDPOINT,
    getSearchTrendsByCountry,
} from "../../api-client/demandSearchTrendsByCountryAPI";

export const searchTrendsByCountryQueryOptions = (params: SearchTrendsByCountryParams) => {
    return queryOptions({
        queryKey: [SEARCH_TRENDS_BY_COUNTRY_ENDPOINT, params],
        queryFn: async ({ signal }) => getSearchTrendsByCountry(params, signal),
    });
};

export type {
    SearchTrendsByCountryParams,
    SearchTrendsByCountryData,
} from "../../api-client/demandSearchTrendsByCountryAPI";
